import React from 'react';
import { ItemType, IUnlabeledItem } from './types';
import { useDrag } from 'react-dnd';
import { makeStyles } from 'design-system';
import cx from 'classnames';
import _ from 'lodash';

interface UnlabeledItemProps {
  unlabeledItem: IUnlabeledItem;
  disabled?: boolean;
}

export const DEFAULT_OPTION_LABEL = 'Option';

const UnlabeledItem: React.FC<UnlabeledItemProps> = props => {
  const classes = useStyles();

  const { unlabeledItem, disabled } = props;
  const label = unlabeledItem.itemLabel || DEFAULT_OPTION_LABEL;
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: ItemType.UnlabeledItem,
      collect: monitor => ({
        isDragging: monitor.isDragging(),
      }),
      item: unlabeledItem,
      canDrag: !disabled,
    }),
    [disabled],
  );

  return (
    <div ref={drag} className={cx(classes.itemContainer, { [classes.isDragging]: isDragging })}>
      {`${label} ${Number(unlabeledItem.id) + 1}`}
    </div>
  );
};

interface UnlabeledItemsProps {
  unlabeledItems: IUnlabeledItem[];
  disabled?: boolean;
}

const UnlabeledItems: React.FC<UnlabeledItemsProps> = ({ unlabeledItems, disabled }) => {
  const classes = useStyles();

  return (
    <div className={classes.itemsContainer}>
      {_.sortBy(unlabeledItems, item => item.id).map(unlabeledItem => {
        return (
          <UnlabeledItem key={unlabeledItem.id} unlabeledItem={unlabeledItem} disabled={disabled} />
        );
      })}
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  itemsContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  itemContainer: {
    transform: 'translate(0, 0)',
    background: theme.colors.white,
    borderRadius: '10px',
    height: '30px',
    width: 'fit-content',
    border: `1px solid ${theme.colors.gray20}`,
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    paddingLeft: '4px',
    paddingRight: '4px',
  },
  isOver: {
    background: 'yellow',
  },
  isDragging: {
    opacity: 0.5,
  },
}));

export default UnlabeledItems;
